import React, { useState, useEffect } from 'react';
import { Button, Form, Modal } from "react-bootstrap";

const AddCompanyModal = ({ show, handleClose }) => {
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState('');
    const [selectedState, setSelectedState] = useState('');



    useEffect(() => {
        fetch('https://countriesnow.space/api/v0.1/countries/')
            .then((response) => response.json())
            .then((data) => {
                setCountries(data.data.map((country) => country.country));
            })
            .catch((error) => console.error('Error fetching countries:', error));
    }, []);

    const handleCountryChange = (e) => {
        const country = e.target.value;
        setSelectedCountry(country);
        setSelectedState(''); // Reset state and city when country changes
        setCities([]);

        fetch(`https://countriesnow.space/api/v0.1/countries/states/q?country=${country}`)
            .then((response) => response.json())
            .then((data) => {
                setStates(data.data.states || []);
            })
            .catch((error) => console.error('Error fetching states:', error));
    };

    const handleStateChange = (e) => {
        const state = e.target.value;
        setSelectedState(state);

        fetch(`https://countriesnow.space/api/v0.1/countries/state/cities/q?country=${selectedCountry}&state=${state}`)
            .then((response) => response.json())
            .then((data) => {
                setCities(data.data || []);
            })
            .catch((error) => console.error('Error fetching cities:', error));
    };



    return (
        <>
            <Modal show={show} size="lg" onHide={handleClose}>
                <Modal.Header className="border-0" closeButton>
                    <Modal.Title className="h5">Create Company</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <div className="row">
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Company Name:</Form.Label>
                                    <Form.Control type="text" name="companyName" placeholder="Enter company name" />
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>First Name:</Form.Label>
                                    <Form.Control type="text" name="firstName" placeholder="Enter first name" />
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Last Name:</Form.Label>
                                    <Form.Control type="text" name="lastName" placeholder="Enter last name" />
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Email:</Form.Label>
                                    <Form.Control type="email" name="email" placeholder="Enter email" />
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Country:</Form.Label>
                                    {/* <Form.Control type="text" name="country" placeholder="Enter country" /> */}
                                    <Form.Control className='form-select' as="select" name="country" onChange={handleCountryChange} value={selectedCountry}>
                                        <option value="">Select Country</option>
                                        {countries.map((country, index) => (
                                            <option key={index} value={country}>{country}</option>
                                        ))}
                                    </Form.Control>
                                </Form.Group>
                            </div>

                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>State:</Form.Label>
                                    {/* <Form.Control className='form-select' type="text" name="state" placeholder="Enter state" /> */}
                                    <Form.Control className='form-select' as="select" name="state" onChange={handleStateChange} value={selectedState}>
                                        <option value="">Select State</option>
                                        {states.map((state, index) => (
                                            <option key={index} value={state.name}>{state.name}</option>
                                        ))}
                                    </Form.Control>
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>City:</Form.Label>
                                    {/* <Form.Control className='form-select' type="text" name="city" placeholder="Enter city" /> */}
                                    <Form.Control className='form-select' as="select" name="city">
                                        <option value="">Select City</option>
                                        {cities.map((city, index) => (
                                            <option key={index} value={city}>{city}</option>
                                        ))}
                                    </Form.Control>
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Phone:</Form.Label>
                                    <Form.Control type="tel" name="phone" placeholder="Enter phone number" />
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Password:</Form.Label>
                                    <Form.Control type="password" name="password" placeholder="Enter password" />
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Confirm Password:</Form.Label>
                                    <Form.Control type="password" name="confirmPassword" placeholder="Confirm password" />
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Zip Code:</Form.Label>
                                    <Form.Control type="text" name="zipCode" placeholder="Enter zip code" />
                                </Form.Group>
                            </div>
                        </div>
                        <Button variant="primary" onClick={handleClose}>
                            Save
                        </Button>
                    </Form>
                </Modal.Body>

            </Modal>
        </>
    );
};

export default AddCompanyModal;